<template>
  <v-container fluid tag="section">
    <base-material-table
      outlined
      :item="item"
      :excel="excel"
      ref="table"
    >
    <template v-slot:condition>
      <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0" v-if="!$isMobile">
        <base-material-date
          outlined dense
          hide-details
          range
          label='创建时间'
          clearable
          width='270'
          @on-change='loadData'
          v-model="item.params.createTime"
        >
        </base-material-date>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0">
        <base-marerial-user-select @on-change="loadData"  label='工单负责人' hide-details outlined dense v-model="item.params.firstPersonIds" mid :menu='$constants.SysMenu.ORDER_M_ID'></base-marerial-user-select>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0">
        <base-marerial-user-select @on-change="loadData"  label='工单协同人' hide-details outlined dense v-model="item.params.assistPersonsIds" mid :menu='$constants.SysMenu.ORDER_M_ID'></base-marerial-user-select>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0">
        <base-marerial-user-select @on-change="loadData"  label='业务负责人' hide-details outlined dense v-model="item.params.signUserIds" mid></base-marerial-user-select>
      </v-col>
      <v-col cols="12" md='2' class="pr-2 pb-0 pt-c-10 px-0" v-if="!$isMobile">
        <v-select
          :items="patentPurposesItems"
          label="软著类型"
          v-model="item.params.purposes"
          hide-details='auto'
          outlined dense
          clearable
          @change="loadData"
          item-text="name"
          item-value="id"
          clear-icon="mdi-close-circle-outline"
        ></v-select>
      </v-col>
      <v-col cols="12" md='2'>
          <v-select-search
            hide-details
            outlined dense
            label="年份选择"
            :data='yearItems'
            @on-change="loadData"
            item-text="label"
            item-value="value"
            clearable
            multiple
            clear-icon="mdi-close-circle-outline"
            v-model='item.params.years'>
          </v-select-search>
        </v-col>
    </template>
     <template v-slot:expanded-content="{ headers, item, refresh }">
       <div v-if='$isMobile && refresh'>
          <v-divider></v-divider>
          <detail-view :item='item' show-arrows></detail-view>
        </div>
        <td :colspan="headers.length" v-else-if='refresh' class="px-0">
          <detail-view :item='item'></detail-view>
        </td>
      </template>
    </base-material-table>
    <add-persion :item='persionModal' @on-load-data='loadData'></add-persion>
    <assignment-view :item='assigModal' @on-load-data='loadData'></assignment-view>
    <step-view :item='stepModal' @on-load-data='loadData'></step-view>
    <edit-view :item='editModal' @on-load-data='loadData'></edit-view>
    <soft-settle :item='settleModal' @on-load-data='loadData'></soft-settle>
    <audit-settle :item='auditSettleModal' @on-load-data='loadData'></audit-settle>
    <commission-settle :item='commSettleModal' @on-load-data='loadData'></commission-settle>
     <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="text-h6">
          系统提示
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <div class="text-h6 pa-2">
              确定【 {{form.tip}}】此工单吗？
              <p class="my-0 size-10 red--text" v-if="form.orderStatus === 3">注意：如有子工单也将一并退回</p>
            </div>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='4' label="备注信息" hide-details='auto' outlined :rules="form.orderStatus === -1 || form.orderStatus === 3 ||  form.orderStatus === 6 ? required : []" v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end p4-1">
          <v-btn text color="grey" @click="dialog = false">取消</v-btn>
          <v-btn color="primary" :loading="loading" depressed  @click="save">
            确定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save } from '@/api/order/index.js'
  import { isEmpty } from '@/utils/stringUtil.js'
  import { selectData2 } from '@/utils/tool.js'
  import SoftSettle from '@/views/pages/pc/copyright/software/settle/Add.vue'
  import VSelectSearch from '@/components/select/v-select-search.vue'
  import DetailView from './Detail.vue'
  import EditView from './components/Edit.vue'
  import AddPersion from './components/Persion.vue'
  import StepView from './components/Step.vue'
  import AssignmentView from './components/Assignment.vue'
  import CommissionSettle from '../step/components/CommissionSettle.vue'
  import AuditSettle from '../step/components/AuditSettle.vue'

  export default {
    name: 'OrderIndex',
    components: {
      AddPersion,
      DetailView,
      AssignmentView,
      StepView,
      SoftSettle,
      AuditSettle,
      CommissionSettle,
      VSelectSearch,
      EditView
    },
    data() {
      return {
        tab: 0,
        form: {},
        dialog: false,
        loading: false,
        yearItems: selectData2(),
        patentPurposesItems: [],
        orderUrgentLevelItems: [],
        editModal: { show: false, data: {} },
        stepModal: { show: false, data: {} },
        assigModal: { show: false, data: {} },
        settleModal: { show: false, data: {} },
        persionModal: { show: false, data: {} },
        orderAddModal: { show: false, data: {} },
        commSettleModal: { show: false, data: {} },
        auditSettleModal: { show: false, data: {} },
        required: [
          value => !!value || '此项为必填项!'
        ],
        item: {
          mobile: true,
          path: 'order/info/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'download', show: this.$_has('order-info-down') },
          ],
          sort: {
            orderByField: 'if(order_status >= 0 and order_status < 3,1,0) desc,urgent_level_id desc,create_time',
            asc: false
          },
          params: {
            createTime: [],
            firstPersonIds: [],
            signUserIds: [],
            assistPersonsIds: [],
            years: []
          },
          headers: [
            {
              text: '详情',
              align: 'center',
              divider: true,
              width: 60,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              value: '',
              mobile: true,
              sortable: false,
              icon: {
                value: 'mdi-dots-horizontal',
                onClick: (row, idx) => {
                  this.$refs.table.showMore(row, idx)
                }
              }
            },
            {
              text: '紧急程度',
              align: 'center',
              divider: true,
              value: 'urgentLevelDic',
              sortable: true,
              sortKey: 'urgent_level_id',
              mobile: true,
              width: 150,
              search: {
                mobile: true,
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                secKey: 'urgentLevelId',
                options: () => this.orderUrgentLevelItems
              },
              select: {
                value: (val) => val.id,
                color: (val) => (val.id === 180 ? 'red' : val.id === 179 ? 'warning' : 'green'),
                itemText: 'name',
                itemValue: 'id',
                disabled: (row) => !this.$_has('order-info-step') || row.orderStatus > 4 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1),
                options: () => this.orderUrgentLevelItems,
                onChange: (item, val) => this.edit(item, val)
              }
            },
            {
              text: '产品名称',
              align: 'center',
              divider: true,
              value: 'product.name',
              sortable: false,
              width: 210,
              mobile: true,
              copy: true,
              search: { type: 'input' }
            },
            {
              text: '客户名称',
              align: 'center',
              divider: true,
              value: 'customer.name',
              sortable: false,
              mobile: true,
              width: 200,
              copy: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '工单状态',
              align: 'center',
              divider: true,
              value: 'orderStatusVal',
              sortable: false,
              width: 100,
              mobile: true,
              search: {
                mobile: true,
                type: 'select',
                secKey: 'orderStatus',
                options: () => [
                  { label: '未接收', value: 0 },
                  { label: '已接收', value: 1 },
                  { label: '进行中', value: 2 },
                  { label: '已退回', value: 3 },
                  { label: '已完成', value: 4 },
                  { label: '已通过', value: 5 },
                  { label: '未通过', value: 6 },
                  { label: '已终止', value: -1 },
                  { label: '终止审核中', value: 7 },
                ]
              }
            },
            {
              text: '年度',
              align: 'center',
              divider: true,
              value: 'contract.year',
              mobile: true,
              sortable: false,
              width: 110,
              formatter: (val, row) => {
                if (this.$constants.ProductType.AuditReport.indexOf(row.product.id) !== -1) {
                  return `${row.doYear || val}[${row.years}]`
                }
                return row.doYear || val
              }
            },
            {
              text: '业务负责人',
              align: 'center',
              divider: true,
              value: 'contract.contactsPersonList',
              sortable: false,
              mobile: true,
              width: 180,
              formatter: (val) => {
                let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|"))
              }
            },
            {
              text: '工单负责人',
              align: 'center',
              divider: true,
              value: 'firstPersonList',
              sortable: false,
              mobile: true,
              width: 120,
              formatter: (val) => {
                let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|"))
              }
            },
            {
              text: '协同人',
              align: 'center',
              width: 200,
              divider: true,
              value: 'assistPersonList',
              sortable: true,
              sortKey: 'assist_persons',
              mobile: true,
              formatter: (val) => {
                let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|")) || '--'
              }
            },
            {
              text: '创建时间',
              align: 'center',
              value: 'createTime',
              sortable: true,
              mobile: true,
              divider: true,
              width: 120,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '关联合同',
              align: 'center',
              divider: true,
              width: 90,
              value: 'relationContractInfos',
              sortable: false,
              formatter: (val) => (val.length > 1 ? `+${val.length - 1}` : 0)
            },
            {
              text: '产品数量',
              align: 'center',
              divider: true,
              width: 90,
              mobile: true,
              value: 'contract.productNumber',
              sortable: false
            },
            {
              text: '结算 (软著)',
              align: 'center',
              divider: true,
              width: 100,
              value: 'orderSettleList',
              sortable: false,
              formatter: (val, row) => {
                let number = 0
                val.forEach(item => {
                  number += item.settleNumber
                })
                return `${number}/${row.contract.productNumber}`
              }
            },
            {
              text: '是否续报',
              align: 'center',
              divider: true,
              width: 90,
              value: 'again',
              sortable: false,
              formatter: (val) => (val === 0 ? '否' : '是'),
              search: {
                type: 'select',
                options: () => [
                  { label: '否', value: 0 },
                  { label: '是', value: 1 }
                ]
              }
            },
            {
              text: '抄送人',
              align: 'center',
              width: 130,
              divider: true,
              value: 'copyPersonsList',
              sortable: false,
              formatter: (val) => {
                let name = ''
                val.forEach(item => {
                  name += `${item.name}|`
                })
                return name.substring(0, name.lastIndexOf("|"))
              }
            },
            {
              text: '实施时间',
              align: 'center',
              divider: true,
              value: 'startTime',
              sortable: false,
              width: 120,
              formatter: (val) => (isEmpty(val) ? '--' : this.$moment(val * 1000).format('YYYY-MM-DD'))
            },
            {
              text: '工单编号',
              align: 'center',
              divider: true,
              value: 'orderNumber',
              sortable: false,
              copy: true,
              width: 210,
            },
            {
              text: '合同编号',
              align: 'center',
              divider: true,
              copy: true,
              value: 'contract.serialNumber',
              sortable: false,
              mobile: true,
              width: 210,
              search: { type: 'input', secKey: 'serialNumber' }
            },
            {
              text: '创建人',
              align: 'center',
              divider: true,
              value: 'createUser.name',
              sortable: false,
              width: 100,
            },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              sortable: false,
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '编辑',
                    color: 'primary',
                    icon: 'mdi-pencil',
                    onClick: (row) => {
                      this.editModal = { show: true, orderId: row.id, data: row }
                    },
                    disable: (row) => !this.$_has('order-info-step') || (row.orderStatus !== 1 && row.orderStatus !== 2) || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1),
                  },
                  {
                    text: '接收',
                    color: 'primary',
                    icon: 'mdi-chart-box-plus-outline',
                    onClick: (row) => {
                      this.dialog = true
                      this.form = { orderStatus: 2, id: row.id, tip: '接收' }
                    },
                    disable: (row) => !this.$_has('order-info-receive') || row.orderStatus >= 1 || row.orderStatus === -1 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '阶段',
                    color: 'brown',
                    icon: 'mdi-order-bool-descending-variant',
                    onClick: (row) => this.stepModal = { show: true, orderId: row.id, data: row },
                    disable: (row) => !this.$_has('order-info-step') || (row.orderStatus !== 2 && row.orderStatus !== 1) || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '转派',
                    color: 'green',
                    icon: 'mdi-airplane-takeoff',
                    onClick: (row) => this.assigModal = { show: true, data: row },
                    disable: (row) => !this.$_has('order-info-assign') || row.orderStatus >= 2 || row.orderStatus === -1 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '退回',
                    color: 'warning',
                    icon: 'mdi-arrow-u-left-top-bold',
                    onClick: (row) => {
                      this.dialog = true
                      this.form = { orderStatus: 3, id: row.id, tip: '退回' }
                    },
                    disable: (row) => !this.$_has('order-info-back') || row.orderStatus > 2 || row.orderStatus === -1 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1) || row.parentId
                  },
                  {
                    text: '通过',
                    color: 'amber',
                    icon: 'mdi-check-underline-circle-outline',
                    onClick: (row) => {
                      this.dialog = true
                      this.form = { orderStatus: 5, id: row.id, tip: '通过' }
                    },
                    disable: (row) => !this.$_has('order-info-step') || row.orderStatus !== 4 || row.orderStatus > 4 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '提成',
                    color: 'amber',
                    icon: 'mdi-alarm-panel',
                    onClick: (row) => {
                      let s = 0
                      row.commissionRecords.forEach(obj => {
                        s += obj.money
                      })
                      if (row.product.commissionPrice * row.contract.productNumber - s > 0) {
                        this.commSettleModal = { show: true, data: row }
                      } else {
                        this.$dialog.notify.warning('已无剩余提成')
                      }
                    },
                    disable: (row) => !this.$_has('order-info-step') || (row.orderStatus !== 4 && row.orderStatus !== 5 && row.orderStatus !== 6) || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '未通过',
                    color: 'red',
                    icon: 'mdi-progress-close',
                    onClick: (row) => {
                      this.dialog = true
                      this.form = { orderStatus: 6, id: row.id, tip: '未通过' }
                    },
                    disable: (row) => !this.$_has('order-info-step') || row.orderStatus !== 4 || row.orderStatus > 4 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '抄送人',
                    color: 'purple',
                    icon: 'mdi-account-plus',
                    onClick: (row) => this.persionModal = { show: true, data: row },
                    disable: (row) => !this.$_has('order-info-edit') || row.orderStatus !== 2 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1)
                  },
                  {
                    text: '子工单',
                    color: 'green',
                    icon: 'mdi-pencil-plus',
                    onClick: (row) => this.child(row),
                    disable: (row) => !this.$_has('order-info-edit') || row.orderStatus !== 2 || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1) || !row.contract.bookkeeping || row.contract.bookkeepingList.length === 0 || (row.contract.bookkeepingList.length === 1 && this.$constants.ProductType.AuditReport.indexOf(row.productId) === -1 && this.$constants.ProductType.HighTech.indexOf(row.productId) === -1 && this.$constants.ProductType.RDSubsidy.indexOf(row.productId) === -1) || row.childOrders.length > 0
                  },
                  {
                    text: '软著结算',
                    color: 'green',
                    icon: 'mdi-currency-usd',
                    onClick: (row) => this.settleModal = { show: true, data: row },
                    disable: (row) => !this.$_has('order-info-back') || (row.orderStatus !== 2 && row.orderStatus !== 4) || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1) || this.$constants.ProductType.ZhuZuoQuan.indexOf(row.product.id) === -1 || row.orderSettleList.length >= row.contract.productNumber
                  },
                  {
                    text: '审计结算',
                    color: 'green',
                    icon: 'mdi-currency-usd',
                    onClick: (row) => this.auditSettleModal = { show: true, data: row, out: 0 },
                    disable: (row) => !this.$_has('order-info-back') || (row.firstPersons.indexOf(this.$store.state.userInfo.id) === -1 && this.$store.state.userInfo.roleIds.indexOf(1) === -1) || this.$constants.ProductType.AuditReport.indexOf(row.product.id) === -1 // || row.orderAuditSettles.filter(set => set.pay === 1).length > 0
                  },
                ]
              }
            }
          ]
        },
        excel: {
          path: 'order/info/down',
          filename: `工单信息.xls`,
          fields: {
            客户名称: 'customer.name',
            合同状态: 'contract.stateDic.name',
            合同单号: 'contract.serialNumber',
            签订项目: 'product.name',
            项目年份: 'contract.year',
            签定数量: 'contract.productNumber',
            工单状态: 'orderStatusVal',
            紧急程度: 'urgentLevelDic.name',
            业务人员: {
              field: 'contract.contactsPersonList',
              callback: (value) => {
                let name = ''
                value.forEach(us => {
                  name += `${us.name},`
                })
                return name
              }
            },
            主负责人: {
              field: 'firstPersonList',
              callback: (value) => {
                let name = ''
                value.forEach(us => {
                  name += `${us.name},`
                })
                return name
              }
            },
            协同人员: {
              field: 'assistPersonList',
              callback: (value) => {
                let name = ''
                value.forEach(us => {
                  name += `${us.name},`
                })
                return name
              }
            },
            创建时间: {
              field: 'createTime',
              callback: (value) => this.$moment(value * 1000).format('YYYY-MM-DD')
            }
          }
        }
      }
    },
    methods: {
      add () {
        this.addModal = { show: true }
      },
      edit (item, val) {
        const form = { id: item.id, urgentLevelId: val.id }
        this.$dialog.confirm({
          text: `确认将【${item.product.name}】改为【${val.name}】状态吗?`,
          title: '系统提示',
          width: 320,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                save(form).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      child (row) {
        const bookkeeping = row.contract.bookkeepingDic[0]
        const order = {
          personId: Number(bookkeeping.key),
          orderNumber: row.orderNumber,
          urgentLevelId: row.urgentLevelId,
          startTime: row.startTime,
          productId: Number(bookkeeping.code),
          customerId: row.customerId,
          contractId: row.contractId,
          parentId: row.id,
          remark: '',
        }
        this.$dialog.confirm({
          text: `确认发放【${bookkeeping.name}】工单吗?`,
          title: '系统提示',
          width: 320,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                save(order).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      },
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.loadData()
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
            this.dialog = false
          })
        }
      },
      loadData () {
        this.$refs.table.loadData()
      },
      async getSelectItems () {
        await getByPids(
            {
            pids: [
              this.$constants.orderUrgentLevelPid,
              this.$constants.patentPurposesPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
            const this_ = this
            res.data.forEach((result) => {
              if (this_.$constants.orderUrgentLevelPid === result.id) {
                this_.orderUrgentLevelItems = result.data
              } else if (this_.$constants.patentPurposesPid === result.id) {
                this_.patentPurposesItems = result.data
             }
            })
          }
        })
      }
    },
    created() {
      this.getSelectItems()
    }
  }
</script>

<style>
</style>
